import { Row, Col } from 'react-bootstrap';
import { Input } from 'appkit-react';

const RoundUpComponent = ({
    sourceRoundUp, sourceRoundError, onSourceRoundUp, targetRoundUp, targetRoundError,
    onTargetRoundUp,
}) => (
    <Row>
        <Col>
            <p className="true-comply-datarecon__reconcliationtype-sum__column">SOURCE COLUMN ROUND</p>
            <div className="true-comply-datarecon__reconcliationtype-sum__select">
                <Input
                    placeholder="Value"
                    inputBoxSize="sm"
                    value={sourceRoundUp}
                    hasError={sourceRoundError}
                    errMsg="Only positive and negative numbers are allowed."
                    onChange={onSourceRoundUp}
                />
            </div>
        </Col>
        <Col>
            <p className="true-comply-datarecon__reconcliationtype-sum__column">TARGET COLUMN ROUND</p>
            <div className="true-comply-datarecon__reconcliationtype-sum__select">
                <Input
                    placeholder="Value"
                    inputBoxSize="sm"
                    hasError={targetRoundError}
                    errMsg="Only positive and negative numbers are allowed."
                    value={targetRoundUp}
                    onChange={onTargetRoundUp}
                />
            </div>
        </Col>
    </Row>
);

export default RoundUpComponent;
